const SUPPORTED_FEATURES = {
  applicationReview: 'APPLICATION_REVIEW_ENABLED',
};

/**
 * Retrieves all enabled features for a specific tenant based on environment variables.
 * @param {object} env - The environment object (process.env or equivalent).
 * @param {string} tenantId - The tenant ID to validate.
 * @returns {object} An object with feature flags and their boolean values for the tenant.
 */
const getEnabledFeatures = (env, tenantId) => {
  if (!env || !tenantId) {
    throw new Error('Environment and tenant ID are required.');
  }

  // eslint-disable-next-line no-unused-vars
  return Object.entries(SUPPORTED_FEATURES).reduce((features, [featureKey, envVar]) => {
    const featureValue = env[envVar]; // Read feature flag value from environment variables
    if (!featureValue) {
      return features;
    }
    const enabledTenants = featureValue ? featureValue.split(',').map((t) => t.trim()) : [];

    // Check if the tenant is enabled explicitly or via wildcard (*)
    features[envVar] = enabledTenants.includes('*') || enabledTenants.includes(tenantId);
    return features;
  }, {});
};
module.exports = {
  SUPPORTED_FEATURES,
  getEnabledFeatures,
};
